import { ReactNode } from "react";
import styled from "@emotion/styled";
import { useRouterState } from "@tanstack/react-router";
import { Layout } from "antd5";

import { AnnouncementCard } from "components/product_announcements/AnnouncementCard";
import { BidOrchestratorDriverHost } from "lib/providers/bid_orchestrator/BidOrchestratorDriverHost";
import { BidOrchestratorStreamProvider } from "lib/providers/bid_orchestrator/BidOrchestratorStreamProvider";
import { DocumentViewerProvider } from "lib/providers/DocumentViewer";
import { PaywallProvider } from "lib/providers/Paywall";
import { RecordViewerProvider } from "lib/providers/RecordViewer";
import BookADemoFromUrl from "../account_management/BookADemoFromUrl";
import AppContentLayout from "./AppContentLayout";

// TODO: remove antd Layout with custom component
const PageLayout = styled(Layout)(({ theme }) => ({
  height: "100vh",
  background: theme.colors.sysBackgroundDefault,
  "& .ant5-layout-footer": {
    fontSize: "16px",
  },
}));

type AppShellProps = {
  children: ReactNode;
  trackingPageName?: string;
};

export function AppShell({ children, trackingPageName }: AppShellProps): JSX.Element {
  const routePathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <PageLayout>
      <PaywallProvider trackingPageName={trackingPageName}>
        <BookADemoFromUrl>
          <AnnouncementCard />
          <BidOrchestratorStreamProvider>
            {/* Single dispatcher for bid orchestrator — one hook iterating the
                whole queue. Reads upload progress from the root-level
                DocumentUploadProgressProvider (in RootLayout) via context. */}
            <BidOrchestratorDriverHost />
            <RecordViewerProvider>
              <DocumentViewerProvider>
                <AppContentLayout routePathname={routePathname}>{children}</AppContentLayout>
              </DocumentViewerProvider>
            </RecordViewerProvider>
          </BidOrchestratorStreamProvider>
        </BookADemoFromUrl>
      </PaywallProvider>
    </PageLayout>
  );
}
